import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3a3ad1da")

_pushScopeId("data-v-3a3ad1da")
const _hoisted_1 = { class: "text-align-center" }
const _hoisted_2 = { class: "detail-title" }
const _hoisted_3 = {
  key: 0,
  class: "detail-title"
}
const _hoisted_4 = { class: "detail-label detail-label-title" }
const _hoisted_5 = { class: "detail-label" }
const _hoisted_6 = { class: "detail-label detail-label-title" }
const _hoisted_7 = { class: "detail-label" }
const _hoisted_8 = { class: "detail-label detail-label-title" }
const _hoisted_9 = { class: "detail-label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_device_info_setting_dialog = _resolveComponent("device-info-setting-dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("b", _hoisted_2, _toDisplayString(_ctx.$wordList.DeviceDetailTitle) + _toDisplayString(_ctx.MAC), 1)
    ]),
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(_component_cus_button, {
      type: "blue",
      onClick: _ctx.showSettingDialog,
      class: "btn-setting"
    }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextSetting), 1)
      ]),
      _: 1
    }, 8, ["onClick"]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailForm, (item) => {
      return (_openBlock(), _createBlock("div", { key: item }, [
        (item.type == _ctx.titleType)
          ? (_openBlock(), _createBlock("b", _hoisted_3, _toDisplayString(item.label), 1))
          : _createCommentVNode("", true),
        (item.type == _ctx.labelType)
          ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _createVNode("label", _hoisted_4, _toDisplayString(item.label) + ":", 1),
              _createVNode("label", _hoisted_5, _toDisplayString(item.text?item.text:'--'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (item.type == _ctx.gradeType)
          ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
              _createVNode("label", _hoisted_6, _toDisplayString(item.label) + ":", 1),
              _createVNode("label", _hoisted_7, _toDisplayString(_ctx.getDeviceType(_ctx.type)[Number(item.text)]), 1)
            ], 64))
          : _createCommentVNode("", true),
        (item.type == _ctx.publicDeviceType && item.text)
          ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
              _createVNode("label", _hoisted_8, _toDisplayString(item.label) + ":", 1),
              _createVNode("label", _hoisted_9, _toDisplayString(item.text?item.text:'--'), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    (_ctx.isShowDeviceInfoSettingDialog)
      ? (_openBlock(), _createBlock(_component_device_info_setting_dialog, {
          key: 0,
          onClose: _ctx.closeInfo,
          initForm: _ctx.initForm,
          identity: "super",
          projectType: _ctx.projectType
        }, null, 8, ["onClose", "initForm", "projectType"]))
      : _createCommentVNode("", true)
  ]))
})